<ng-container *ngIf="embedUrl; else videoImagePlaceHolder">
  <div class="embed-container" [ngClass]="containerCss ? containerCss : ''">
    <!--EMBEDDED VIDEO IFRAME-->
    <iframe
      [attr.title]="title"
      [src]="embedUrl | safe : 'resourceUrl'"
      allowtransparency="true"
      frameborder="0"
      scrolling="no"
      class="wistia_embed"
      name="wistia_embed"
      allowfullscreen
      mozallowfullscreen
      webkitallowfullscreen
      oallowfullscreen
      msallowfullscreen
      appIframeTracker
      (iframeClick)="onIframeClick()">
    </iframe>
    <!--END EMBEDDED VIDEO IFRAME-->
  </div>
</ng-container>

<ng-template #videoImagePlaceHolder>
  <div class="image-placeholder">
    <!-- <app-loading-spinner></app-loading-spinner> -->

    <i class="icon white x-large No-Results-Icon"></i>
    <p class="bold">Video Not Available</p>
  </div>
</ng-template>
